export default {
    congratulation: 'ยินดีด้วย',
    message: 'บันทึกสำเร็จ',
    close: 'ปิด'
}
